import { render, staticRenderFns } from "./LabelGroups.vue?vue&type=template&id=10c8e6da&scoped=true"
import script from "./LabelGroups.vue?vue&type=script&lang=js"
export * from "./LabelGroups.vue?vue&type=script&lang=js"
import style0 from "./LabelGroups.vue?vue&type=style&index=0&id=10c8e6da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c8e6da",
  null
  
)

export default component.exports